import React from 'react';
import Employee from '../components/employee/Empolyee'
import OrganizationChart from '../components/orgchart/Orgnizationchart';

const OrganizationChartPage = () => {

  return (
    <>
        <OrganizationChart />
    </>
  )
}

export default OrganizationChartPage
